import { defineComponent as _defineComponent } from 'vue';
import { computed, ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ConfidentialField',
    props: {
        value: null,
        maskLength: { default: 8 }
    },
    setup(__props) {
        const props = __props;
        const showData = ref(false);
        const maskData = computed(() => "*".repeat(props.value?.length ?? props.maskLength));
        const btnIcon = computed(() => showData.value ? 'mdi-eye-off' : 'mdi-eye');
        return { __sfc: true, props, showData, maskData, btnIcon };
    }
});
